import { jwtDecode } from "jwt-decode";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import ApiService from "services/ApiService";
import { signIn, signOut } from "./authSlice";

export const initialState = {
  firstName: "",
  lastName: "",
  email: "",
  loading: false,
  message: "",
  showMessage: false,
  success: true,
  userId: "",
  users: [],
  appUsers: [],
  admins: [],
  connectToBC: false,
  integration: [],
};

export const fetchUsers = createAsyncThunk(
  "user/fetchUsers",
  async (data, { rejectWithValue }) => {
    try {
      const response = await ApiService.getUsers(data);
      if (response.status === 200) {
        return response.data.data;
      } else return rejectWithValue(response.data);
    } catch (err) {
      return rejectWithValue(
        err.response || "Something went wrong while fetching users.",
      );
    }
  },
);

export const fetchAdmins = createAsyncThunk(
  "user/fetchAdmins",
  async (data, { rejectWithValue }) => {
    try {
      const response = await ApiService.getAdmins(data);
      if (response.status === 200) {
        return response.data;
      } else return rejectWithValue(response.data);
    } catch (err) {
      return rejectWithValue(
        err.response || "Something went wrong while fetching admins.",
      );
    }
  },
);

export const addUser = createAsyncThunk(
  "user/addUser",
  async (data, { rejectWithValue }) => {
    try {
      const response = await ApiService.addUser(data);
      if (response.status === 200) {
        return response.data;
      } else return rejectWithValue(response.data);
    } catch (err) {
      return rejectWithValue(
        err.response || "Something went wrong while adding user.",
      );
    }
  },
);

export const addIntegratorUser = createAsyncThunk(
  "user/addIntegratorUser",
  async (data, { rejectWithValue }) => {
    try {
      const response = await ApiService.addUser(data);
      if (response.status === 200) {
        return response.data;
      } else return rejectWithValue(response.data);
    } catch (err) {
      return rejectWithValue(
        err.response || "Something went wrong while adding user.",
      );
    }
  },
);

export const addAdmin = createAsyncThunk(
  "user/addAdmin",
  async (data, { rejectWithValue }) => {
    try {
      const response = await ApiService.addAdmin(data);
      if (response.status === 200) {
        return response.data;
      } else return rejectWithValue(response.data);
    } catch (err) {
      return rejectWithValue(
        err.response || "Something went wrong while adding admin.",
      );
    }
  },
);

export const activateUser = createAsyncThunk(
  "user/activateUser",
  async (data, { rejectWithValue }) => {
    try {
      const response = await ApiService.activateUser(data);
      if (response.status === 200) {
        return response.data;
      } else return rejectWithValue(response.data);
    } catch (err) {
      return rejectWithValue(
        err.response || "Something went wrong while activating user.",
      );
    }
  },
);

export const reactivateUser = createAsyncThunk(
  "user/reactivateUser",
  async (data, { rejectWithValue }) => {
    try {
      const response = await ApiService.reactivateUser(data);
      if (response.status === 200) {
        return response.data;
      } else return rejectWithValue(response.data);
    } catch (err) {
      return rejectWithValue(
        err.response || "Something went wrong while reactivating user.",
      );
    }
  },
);

export const activateAdmin = createAsyncThunk(
  "user/activateAdmin",
  async (data, { rejectWithValue }) => {
    try {
      const response = await ApiService.activateAdmin(data);
      if (response.status === 200) {
        return response.data;
      } else return rejectWithValue(response.data);
    } catch (err) {
      return rejectWithValue(
        err.response || "Something went wrong while activating admin.",
      );
    }
  },
);

export const deactivateUser = createAsyncThunk(
  "user/deactivateUser",
  async (data, { rejectWithValue }) => {
    try {
      const response = await ApiService.deactivateAdmin(data);
      if (response.status === 200) {
        return response.data;
      } else return rejectWithValue(response.data);
    } catch (err) {
      return rejectWithValue(
        err.response || "Something went wrong while deactivating admin.",
      );
    }
  },
);

export const approveRejectUserAccessStatus = createAsyncThunk(
  "user/approveRejectUserAccessStatus",
  async (data, { rejectWithValue }) => {
    try {
      const response = await ApiService.approveRejectAccessRequest(data);
      if (response.status === 200) {
        return response.data;
      } else return rejectWithValue(response.data);
    } catch (err) {
      return rejectWithValue(
        err.response ||
          "Something went wrong while updating user access request status.",
      );
    }
  },
);

export const editUser = createAsyncThunk(
  "user/editUser",
  async (data, { rejectWithValue }) => {
    try {
      const response = await ApiService.editUser(data);
      if (response.status === 200) {
        return response.data;
      } else return rejectWithValue(response.data);
    } catch (err) {
      return rejectWithValue(
        err.response || "Something went wrong while editing user.",
      );
    }
  },
);

export const editAdmin = createAsyncThunk(
  "user/editAdmin",
  async (data, { rejectWithValue }) => {
    try {
      const response = await ApiService.editAdmin(data);
      if (response.status === 200) {
        return response.data;
      } else return rejectWithValue(response.data);
    } catch (err) {
      return rejectWithValue(
        err.response || "Something went wrong while editing admin.",
      );
    }
  },
);

export const deleteUser = createAsyncThunk(
  "user/deleteUser",
  async (data, { rejectWithValue }) => {
    try {
      const response = await ApiService.deleteUser(data);
      if (response.status === 200) {
        return {
          success: response.data.success,
          message: response.data.message,
          userId: data.userId,
        };
      } else return rejectWithValue(response.data);
    } catch (err) {
      return rejectWithValue(
        err.response || "Something went wrong while deleting user.",
      );
    }
  },
);

export const deleteAdmin = createAsyncThunk(
  "user/deleteAdmin",
  async (data, { rejectWithValue }) => {
    try {
      const response = await ApiService.deleteAdmin(data);
      if (response.status === 200) {
        return {
          success: response.data.success,
          message: response.data.message,
          adminId: data.id,
        };
      } else return rejectWithValue(response.data);
    } catch (err) {
      return rejectWithValue(
        err.response || "Something went wrong while deleting admin.",
      );
    }
  },
);

export const fetchApplicationUsers = createAsyncThunk(
  "user/fetchApplicationUsers",
  async (data, { rejectWithValue }) => {
    try {
      const response = await ApiService.getApplicationUsers(data);
      if (response.status === 200) {
        return response.data.data;
      } else return rejectWithValue(response.data);
    } catch (err) {
      return rejectWithValue(
        err.response ||
          "Something went wrong while fetching application users.",
      );
    }
  },
);

export const switchCustomerAccount = createAsyncThunk(
  "user/switchCustomerAccount",
  async (data, { rejectWithValue }) => {
    try {
      const response = await ApiService.switchCustomerAccount(data);
      if (response.status === 200) {
        return response.data;
      } else return rejectWithValue(response.data);
    } catch (err) {
      return rejectWithValue(
        err.response ||
          "Something went wrong while switching customer account.",
      );
    }
  },
);

export const getNonOperationalVendors = createAsyncThunk(
  "/non-operational-vendors",
  async (data, { rejectWithValue, getState }) => {
    try {
      const response = await ApiService.getNonOperationalVendors();
      if (response.status === 200) {
        return response.data;
      } else return rejectWithValue(response.data);
    } catch (err) {
      return rejectWithValue(
        err.response ||
          "Something went wrong while fetching non-operational vendors.",
      );
    }
  },
);

export const deactivateOktaUser = createAsyncThunk(
  "user/deactivateOktaUser",
  async (data, { rejectWithValue }) => {
    try {
      const response = await ApiService.deactivateUser(data);
      if (response.status === 200) {
        return response.data;
      } else return rejectWithValue(response.data);
    } catch (err) {
      return rejectWithValue(
        err.response || "Something went wrong while deactivating user.",
      );
    }
  },
);

export const unlockUserAccount = createAsyncThunk(
  "user/unlockUserAccount",
  async (data, { rejectWithValue }) => {
    try {
      const response = await ApiService.unlockUserAccount(data);
      if (response.status === 200) {
        return response.data;
      } else return rejectWithValue(response.data);
    } catch (err) {
      return rejectWithValue(
        err.response || "Something went wrong while unlocking user account.",
      );
    }
  },
);

export const resetUserPassword = createAsyncThunk(
  "user/resetUserPassword",
  async (data, { rejectWithValue }) => {
    try {
      const response = await ApiService.resetUserPassword(data);
      if (response.status === 200) {
        return response.data;
      } else return rejectWithValue(response.data);
    } catch (err) {
      return rejectWithValue(
        err.response || "Something went wrong while resetting user password.",
      );
    }
  },
);

export const fetchUserIntegrations = createAsyncThunk(
  "user/fetchUserIntegrations",
  async (data, { rejectWithValue }) => {
    try {
      const response = await ApiService.getUserIntegrations(data);
      if (response.status === 200) {
        return response.data;
      } else return rejectWithValue(response.data);
    } catch (err) {
      return rejectWithValue(
        err.response ||
          "Something went wrong while fetching user integrations.",
      );
    }
  },
);

export const updateUserIntegration = createAsyncThunk(
  "user/updateUserIntegration",
  async (data, { rejectWithValue }) => {
    try {
      const response = await ApiService.updateUserIntegration(data);
      if (response.status === 200) {
        return response.data;
      } else return rejectWithValue(response.data);
    } catch (err) {
      return rejectWithValue(
        err.response ||
          "Something went wrong while updating the customer integrator.",
      );
    }
  },
);

export const fetchUserDetails = createAsyncThunk(
  "user/fetchUserDetails",
  async (data, { rejectWithValue }) => {
    try {
      const response = await ApiService.getUserDetails(data);
      if (response.status === 200) {
        return response.data;
      } else return rejectWithValue(response.data);
    } catch (err) {
      return rejectWithValue(
        err.response || "Something went wrong while fetching user details.",
      );
    }
  },
);

export const setUserPasswordAndActivate = createAsyncThunk(
  "order/setUserPasswordAndActivate",
  async (data, { rejectWithValue, getState }) => {
    try {
      const response = await ApiService.setPassword(data);
      if (response.status === 200) {
        return response.data;
      } else return rejectWithValue(response.data);
    } catch (err) {
      return rejectWithValue(
        err.response ||
          "Something went wrong while fetching integrator details.",
      );
    }
  },
);

export const requestAccess = createAsyncThunk(
  "order/requestAccess",
  async (data, { rejectWithValue, getState }) => {
    try {
      const response = await ApiService.requestAccess(data);
      if (response.status === 200) {
        return response.data;
      } else return rejectWithValue(response.data);
    } catch (err) {
      return rejectWithValue(
        err.response || "Something went wrong while requesting access.",
      );
    }
  },
);

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUserDetails: (state, action) => {
      const { email, firstName, lastName, userId } = action.payload;
      state.email = email;
      state.firstName = firstName;
      state.lastName = lastName;
      state.userId = userId;
    },
    clearMessage: (state, action) => {
      state.message = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(signIn.fulfilled, (state, action) => {
        const decodedToken = jwtDecode(action.payload);
        const {
          sub,
          firstName,
          lastName,
          userId,
          connect_to_bc: connectToBC,
        } = decodedToken;
        state.email = sub;
        state.firstName = firstName;
        state.lastName = lastName;
        state.userId = userId;
        state.connectToBC = connectToBC;
      })
      .addCase(signOut.fulfilled, (state) => {
        return initialState;
      })
      .addCase(fetchUsers.pending, (state) => {
        return { ...state, loading: true };
      })
      .addCase(fetchUsers.fulfilled, (state, action) => {
        return {
          ...state,
          users: action.payload,
          loading: false,
        };
      })
      .addCase(fetchUsers.rejected, (state, action) => {
        return {
          ...state,
          loading: false,
          success: false,
          message: action.payload,
        };
      })
      .addCase(fetchAdmins.pending, (state) => {
        return { ...state, loading: true };
      })
      .addCase(fetchAdmins.fulfilled, (state, action) => {
        const { data } = action.payload;
        return {
          ...state,
          admins: data,
          loading: false,
        };
      })
      .addCase(fetchAdmins.rejected, (state, action) => {
        return {
          ...state,
          loading: false,
          success: false,
          message: action.payload,
        };
      })
      .addCase(fetchApplicationUsers.pending, (state) => {
        return { ...state, loading: true };
      })
      .addCase(fetchApplicationUsers.fulfilled, (state, action) => {
        return {
          ...state,
          appUsers: action.payload,
          loading: false,
        };
      })
      .addCase(fetchApplicationUsers.rejected, (state, action) => {
        const { success, message } = action.payload;
        return {
          ...state,
          loading: false,
          success: success,
          message: message,
        };
      })
      .addCase(addUser.pending, (state) => {
        return { ...state, loading: true };
      })
      .addCase(addUser.fulfilled, (state, action) => {
        const { success, message, data } = action.payload;
        return {
          ...state,
          users: [...state.users, data],
          loading: false,
          message: message,
          success: success,
        };
      })
      .addCase(addUser.rejected, (state, action) => {
        const { success, message } = action.payload;
        return {
          ...state,
          loading: false,
          message: message,
          success: success,
        };
      })
      .addCase(addIntegratorUser.pending, (state) => {
        return { ...state, loading: false };
      })
      .addCase(addIntegratorUser.fulfilled, (state, action) => {
        const { success, message, data } = action.payload;
        return {
          ...state,
          users: [...state.users, data],
          loading: false,
          // message: message,
          success: success,
        };
      })
      .addCase(addIntegratorUser.rejected, (state, action) => {
        const { success, message } = action.payload;
        return {
          ...state,
          loading: false,
          message: message,
          success: success,
        };
      })
      .addCase(addAdmin.pending, (state) => {
        return { ...state, loading: true };
      })
      .addCase(addAdmin.fulfilled, (state, action) => {
        const { success, message, data } = action.payload;
        return {
          ...state,
          admins: [...state.admins, data],
          loading: false,
          message: message,
          success: success,
        };
      })
      .addCase(addAdmin.rejected, (state, action) => {
        const { success, message } = action.payload;
        return {
          ...state,
          loading: false,
          message: message,
          success: success,
        };
      })
      .addCase(activateUser.pending, (state) => {
        return { ...state, loading: true };
      })
      .addCase(activateUser.fulfilled, (state, action) => {
        const { success, message, data } = action.payload;
        const { id, status } = data;
        const updatedUsers = state.users.map((a) => {
          if (a.id === id) {
            return {
              ...a,
              status,
            };
          } else {
            return a;
          }
        });
        return {
          ...state,
          users: updatedUsers,
          loading: false,
          message: message,
          success: success,
        };
      })
      .addCase(activateUser.rejected, (state, action) => {
        const { success, message } = action.payload;
        return {
          ...state,
          loading: false,
          message: message,
          success: success,
        };
      })
      .addCase(reactivateUser.pending, (state) => {
        return { ...state, loading: true };
      })
      .addCase(reactivateUser.fulfilled, (state, action) => {
        const { success, message } = action.payload;
        return {
          ...state,
          loading: false,
          message: message,
          success: success,
        };
      })
      .addCase(reactivateUser.rejected, (state, action) => {
        const { success, message } = action.payload;
        return {
          ...state,
          loading: false,
          message: message,
          success: success,
        };
      })
      .addCase(activateAdmin.pending, (state) => {
        return { ...state, loading: true };
      })
      .addCase(activateAdmin.fulfilled, (state, action) => {
        const { success, message, data } = action.payload;
        const { id, status } = data;
        const updatedAdmins = state.admins.map((a) => {
          if (a.id === id) {
            return {
              ...a,
              status,
            };
          } else {
            return a;
          }
        });
        return {
          ...state,
          admins: updatedAdmins,
          loading: false,
          message: message,
          success: success,
        };
      })
      .addCase(activateAdmin.rejected, (state, action) => {
        const { success, message } = action.payload;
        return {
          ...state,
          loading: false,
          message: message,
          success: success,
        };
      })
      .addCase(deactivateUser.pending, (state) => {
        return { ...state, loading: true };
      })
      .addCase(deactivateUser.fulfilled, (state, action) => {
        const { success, message, data } = action.payload;
        const { id, status } = data;
        const updatedAdmins = state.admins.map((a) => {
          if (a.id === id) {
            return {
              ...a,
              status,
            };
          } else {
            return a;
          }
        });
        return {
          ...state,
          admins: updatedAdmins,
          loading: false,
          message: message,
          success: success,
        };
      })
      .addCase(deactivateUser.rejected, (state, action) => {
        const { success, message } = action.payload;
        return {
          ...state,
          loading: false,
          message: message,
          success: success,
        };
      })
      .addCase(editUser.pending, (state) => {
        return { ...state, loading: true };
      })
      .addCase(editUser.fulfilled, (state, action) => {
        const { success, message, data } = action.payload;
        const { id } = data;
        const editedUsers = state.users.map((a) => {
          if (a.id === id) {
            return data;
          } else {
            return a;
          }
        });
        return {
          ...state,
          users: editedUsers,
          loading: false,
          message: message,
          success: success,
        };
      })
      .addCase(editUser.rejected, (state, action) => {
        const { success, message } = action.payload;
        return {
          ...state,
          loading: false,
          message: message,
          success: success,
        };
      })
      .addCase(editAdmin.pending, (state) => {
        return { ...state, loading: true };
      })
      .addCase(editAdmin.fulfilled, (state, action) => {
        const { success, message, data } = action.payload;
        const { id } = data;
        const editedAdmins = state.admins.map((a) => {
          if (a.id === id) {
            return data;
          } else {
            return a;
          }
        });
        return {
          ...state,
          admins: editedAdmins,
          loading: false,
          message: message,
          success: success,
        };
      })
      .addCase(editAdmin.rejected, (state, action) => {
        const { success, message } = action.payload;
        return {
          ...state,
          loading: false,
          message: message,
          success: success,
        };
      })
      .addCase(deleteUser.pending, (state) => {
        return { ...state, loading: true };
      })
      .addCase(deleteUser.fulfilled, (state, action) => {
        const { success, message, userId } = action.payload;
        return {
          ...state,
          users: state.users.filter((a) => a.userId !== userId),
          loading: false,
          message: message,
          success: success,
        };
      })
      .addCase(deleteUser.rejected, (state, action) => {
        const { success, message } = action.payload;
        return {
          ...state,
          loading: false,
          message: message,
          success: success,
        };
      })
      .addCase(deleteAdmin.pending, (state) => {
        return { ...state, loading: true };
      })
      .addCase(deleteAdmin.fulfilled, (state, action) => {
        const { success, message, adminId } = action.payload;
        return {
          ...state,
          admins: state.admins.filter((a) => a.id !== adminId),
          loading: false,
          message: message,
          success: success,
        };
      })
      .addCase(deleteAdmin.rejected, (state, action) => {
        const { success, message } = action.payload;
        return {
          ...state,
          loading: false,
          message: message,
          success: success,
        };
      })
      .addCase(switchCustomerAccount.pending, (state) => {
        return { ...state, loading: true };
      })
      .addCase(switchCustomerAccount.fulfilled, (state, action) => {
        const { success, message } = action.payload;
        return {
          ...state,
          loading: false,
          message: message,
          success: success,
        };
      })
      .addCase(switchCustomerAccount.rejected, (state, action) => {
        const { success, message } = action.payload;
        return {
          ...state,
          loading: false,
          success: success,
          message: message,
        };
      })
      .addCase(deactivateOktaUser.pending, (state) => {
        return { ...state, loading: true };
      })
      .addCase(deactivateOktaUser.fulfilled, (state, action) => {
        const { success, message, data } = action.payload;
        const { id, status } = data;
        const updatedUsers = state.users.map((a) => {
          if (a.id === id) {
            return {
              ...a,
              status,
            };
          } else {
            return a;
          }
        });
        return {
          ...state,
          users: updatedUsers,
          loading: false,
          message: message,
          success: success,
        };
      })
      .addCase(deactivateOktaUser.rejected, (state, action) => {
        const { success, message } = action.payload;
        return {
          ...state,
          loading: false,
          message: message,
          success: success,
        };
      })
      .addCase(unlockUserAccount.pending, (state) => {
        return { ...state, loading: true };
      })
      .addCase(unlockUserAccount.fulfilled, (state, action) => {
        const { success, message, data } = action.payload;
        const { id, status } = data;
        const updatedUsers = state.users.map((a) => {
          if (a.id === id) {
            return {
              ...a,
              status,
            };
          } else {
            return a;
          }
        });
        return {
          ...state,
          users: updatedUsers,
          loading: false,
          message: message,
          success: success,
        };
      })
      .addCase(unlockUserAccount.rejected, (state, action) => {
        const { success, message } = action.payload;
        return {
          ...state,
          loading: false,
          message: message,
          success: success,
        };
      })
      .addCase(resetUserPassword.pending, (state) => {
        return { ...state, loading: true };
      })
      .addCase(resetUserPassword.fulfilled, (state, action) => {
        const { success, message, data } = action.payload;
        const { id, status } = data;
        const updatedUsers = state.users.map((a) => {
          if (a.id === id) {
            return {
              ...a,
              status,
            };
          } else {
            return a;
          }
        });
        return {
          ...state,
          users: updatedUsers,
          loading: false,
          message: message,
          success: success,
        };
      })
      .addCase(resetUserPassword.rejected, (state, action) => {
        const { success, message } = action.payload;
        return {
          ...state,
          loading: false,
          message: message,
          success: success,
        };
      })
      .addCase(fetchUserIntegrations.pending, (state) => {
        return { ...state, loading: true };
      })
      .addCase(fetchUserIntegrations.fulfilled, (state, action) => {
        const { success, data } = action.payload;

        return {
          ...state,
          integration: data,
          loading: false,
          success: success,
        };
      })
      .addCase(fetchUserIntegrations.rejected, (state, action) => {
        const { success, message } = action.payload;
        return {
          ...state,
          loading: false,
          message: message,
          success: success,
        };
      })
      .addCase(fetchUserDetails.pending, (state) => {
        return { ...state, loading: true };
      })
      .addCase(fetchUserDetails.fulfilled, (state, action) => {
        const { success, data } = action.payload;

        return {
          ...state,
          loading: false,
          success: success,
        };
      })
      .addCase(fetchUserDetails.rejected, (state, action) => {
        const { success, message } = action.payload;
        return {
          ...state,
          loading: false,
          message: message,
          success: success,
        };
      })
      .addCase(updateUserIntegration.pending, (state) => {
        return { ...state, loading: true };
      })
      .addCase(updateUserIntegration.fulfilled, (state, action) => {
        const { success, message, data } = action.payload;
        const exists = state.integration?.some(
          (item) => item.integrator === data.integrator,
        );
        return {
          ...state,
          loading: false,
          message: message,
          success: success,
          integration: exists
            ? state.integration.map((item) =>
                item.integrator === data.integrator ? data : item,
              )
            : [...state.integration, data],
        };
      })
      .addCase(updateUserIntegration.rejected, (state, action) => {
        const { success, message } = action.payload;
        return {
          ...state,
          loading: false,
          message: message,
          success: success,
        };
      })
      .addCase(setUserPasswordAndActivate.pending, (state) => {
        return { ...state, loading: true };
      })
      .addCase(setUserPasswordAndActivate.fulfilled, (state, action) => {
        const { success, message } = action.payload;
        return {
          ...state,
          loading: false,
          success: success,
          message: "",
        };
      })
      .addCase(setUserPasswordAndActivate.rejected, (state, action) => {
        const { success, message } = action.payload;
        return {
          ...state,
          loading: false,
          message: message,
          success: success,
        };
      })
      .addCase(requestAccess.pending, (state) => {
        return { ...state, loading: true };
      })
      .addCase(requestAccess.fulfilled, (state, action) => {
        const { success, message } = action.payload;
        return {
          ...state,
          loading: false,
          success: success,
          // message: message,
        };
      })
      .addCase(requestAccess.rejected, (state, action) => {
        const { success, message, error } = action.payload;
        return {
          ...state,
          loading: false,
          success: success,
          ...(error?.isEmailExist !== true && { message }),
        };
      })
      .addCase(approveRejectUserAccessStatus.pending, (state) => {
        return { ...state, loading: true };
      })
      .addCase(approveRejectUserAccessStatus.fulfilled, (state, action) => {
        const { success, message, data } = action.payload;
        const { oktaUserID, status, requestAccessStatus } = data;
        const updatedUsers = state.users.map((a) => {
          if (a.id === oktaUserID) {
            return {
              ...a,
              status,
              requestAccessStatus: requestAccessStatus,
            };
          } else {
            return a;
          }
        });
        return {
          ...state,
          users: updatedUsers,
          loading: false,
          message: message,
          success: success,
        };
      })
      .addCase(approveRejectUserAccessStatus.rejected, (state, action) => {
        const { success, message } = action.payload;
        return {
          ...state,
          loading: false,
          message: message,
          success: success,
        };
      });
  },
});

export const { setUserDetails, clearMessage } = userSlice.actions;

export default userSlice.reducer;
